<template>
	<div>
		<aside v-if="!ready" class="app-loading">
			<p>Loading Nearest Locations...</p>
		</aside>
		<aside v-if="ready">
			<div class="form mb-4">
				<div class="content">
					<fieldset>
						<label>Enter Zip Code</label>
						<input v-model="searchString"
							   type="number"
							   max="99999"
							   min="0"
							   tabindex="1"
							   required>
					</fieldset>
					<fieldset>
						<label>Search Within</label>
						<select v-model="searchRadius">
							<option value="5">5 Miles</option>
							<option value="20">20 Miles</option>
							<option value="50">50 Miles</option>
							<option value="100">100 Miles</option>
						</select>
						<button class="btn-beltone mt-2" @click="search()">
							<div v-show="loading" class="btn-spinner white">
								<div class="outer"><div class="inner"><span></span></div></div>
							</div>
							<span :class="{'hidden': loading}">Search</span>
						</button>
					</fieldset>
				</div>
			</div>
      <view-advanced v-if="showMap === 'true'"
                     ref="advanced"
                     :searchString="searchString"
                     :searchRadius="searchRadius"
                     :usingSearchString="usingSearchString"
                     :dealer-id="dealerId"/>
			<view-basic v-else :dealer-id="dealerId" />
		</aside>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import EventBus from '../../js/eventBus'
	import Services from '../mixins/services';
	import ViewBasic from './../components/location-search/view-basic'
	import ViewAdvanced from './../components/location-search/view-advanced'

	const MAP_MARKER_SEARCH_RADIUS = 20000;

	export default {
		mixins: [Services],
    props: {
      showMap: {
        type: String,
        default: 'false'
      },
      dealerId: {
        type: String,
        required: true,
      }
    },
		components: {
			ViewBasic,
			ViewAdvanced,
		},
		data: function () {
			return {
				ready: false,
				loading: false,
				searchString: "",
				searchRadius: 20,
				isInitialStateOrCityPageLoad: false,
				isStateOrCityPage: false,
				usingSearchString: false,
				queryParams: null
			}
		},
    computed: mapState({
			geoLocation: state => state.LocationSearch.geoLocation,
			searchResults: state => state.LocationSearch.searchResults,
			clientToken: state => state.ClientToken.clientToken,
		}),
		methods: {
			...mapActions('GoogleApi', { getIpLocation: 'getIpLocation' }),
			...mapActions('ClientToken', { getClientToken: 'getClientToken' }),
			...mapActions('LocationSearch', { updateGeoLocation: 'updateGeoLocation' }),
			...mapActions('LocationSearch', { getSearchResults: 'getSearchResults' }),
			...mapActions('LocationSearch', { resetResults: 'resetResults' }),

      setSearchResults(longitude, latitude, searchRadius) {
				const zipCode = this.queryParams.get('zip');
				const state = this.queryParams.get('state');
				const searchRadiusValue = searchRadius || this.queryParams.get('radius');
        this.getSearchResults({
          Longitude: longitude,
          Latitude: latitude,
          SearchRadius: searchRadiusValue,
          ZipCode: zipCode,
          State: state,
          ExcludeMilesAway: this.isStateOrCityPage,
          PageNumber: 0,
          PageSize: this.showMap === 'true' ? 8 : searchRadiusValue ? 3 : 96,
          replaceData: true,
          dealerId: this.dealerId,
          clientToken: this.clientToken,
					cb: () => {
						this.ready = true;
						if (this.showMap === 'true' && this.$refs.advanced && this.$refs.advanced.$refs.gMaps) {
							this.$refs.advanced.$refs.gMaps.searchLocations();
						}
          }
        })
			},
			setGeolocation(longitude, latitude) {
				this.updateGeoLocation({
					longitude: longitude,
					latitude: latitude,
				});
        this.setSearchResults(longitude, latitude, MAP_MARKER_SEARCH_RADIUS);
			},
			async search() {
				const hasSearchString = this.searchString.length > 0;
				if (!hasSearchString && !this.geoLocation) return;
				this.loading = true;
				this.usingSearchString = hasSearchString;

				if (!hasSearchString) {
					if (this.showMap === 'true') {
						await this.$refs.advanced.$refs.gMaps.searchLocations();
					}
					this.loading = false;
					return;
				}

				let isNum = /^\d+$/.test(this.searchString);
				const zipCode = isNum ? this.searchString : null;
				const city = !isNum ? this.searchString : null;

				this.resetResults();
				this.getSearchResults({
					Longitude: null,
					Latitude: null,
					SearchRadius: this.searchRadius,
					ZipCode: zipCode,
					City: city,
					PageSize: this.showMap === 'true' ? 8 : 3,
					PageNumber: 0,
          dealerId: this.dealerId,
					clientToken: this.clientToken,
					cb: async () => {
						this.usingSearchString = hasSearchString;
						if (this.showMap === 'true' && this.$refs.advanced && this.$refs.advanced.$refs.gMaps) {
							await this.$refs.advanced.$refs.gMaps.searchLocations();
						}
						this.isInitialStateOrCityPageLoad = false;
						this.loading = false;
					}
				})
			},
		},
    mounted() {      
			this.getClientToken({
				cb: () => {
					let useGeoLocation = true;
					this.queryParams = new URLSearchParams(window.location.search);
					this.isStateOrCityPage = (this.queryParams.get('zip') !== null && this.queryParams.get('radius') !== null) || this.queryParams.get('state') !== null;					
          if (this.isStateOrCityPage) {
						this.isInitialStateOrCityPageLoad = true;
						this.setSearchResults();
						useGeoLocation = false;
					}

          let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (isSafari) {
            this.getIpLocation({
							cb: (res) => {
								if (useGeoLocation) {
									this.setGeolocation(res.lng, res.lat);
								}
              }
            })
          } else {
            this.getIpLocation({
							cb: (res) => {
								if (useGeoLocation) {
									this.setGeolocation(res.lng, res.lat);
								}
              }
            });
						navigator.geolocation.getCurrentPosition((position) => {
							if (useGeoLocation) {
								this.setGeolocation(position.coords.longitude, position.coords.latitude);
							}
            });
          }
				}
			});
		}
  }
</script>
